module.exports = __webpack_public_path__ + "img/view.259b4c65.png";